import React from "react";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";

export function AcademyFrame({ children }) {
  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-100" lang="en">
      <SiteHeader />
      <main className="mx-auto max-w-6xl px-5 py-8 md:py-10">{children}</main>
      <SiteFooter />
    </div>
  );
}
